var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M116.49 46.5716L75.4519 87.4402C69.7196 93.1489 66.8534 96.0033 63.2931 96C59.7329 95.9967 56.872 93.1371 51.1503 87.4177L12.0078 48.2915C11.5389 47.8229 11.3045 47.5886 11.1195 47.3777C8.28952 44.1517 8.294 39.3379 11.13 36.1171C11.3154 35.9066 11.5502 35.6727 12.0199 35.205C12.5027 34.7241 12.7441 34.4837 12.9599 34.2958C16.2668 31.4154 21.2237 31.4864 24.446 34.4604C24.6562 34.6544 24.8905 34.9015 25.359 35.3958L51.1605 62.6138C56.864 68.6305 59.7158 71.6389 63.3436 71.6908C66.9713 71.7428 69.9088 68.8174 75.7838 62.9667L104.368 34.5001C107.715 31.1666 113.142 31.1666 116.49 34.5001C119.837 37.8335 119.837 43.2381 116.49 46.5716Z","fill":"#333333"}));
}

Arrow.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
